import fetchData, { APIURL } from "../fetch";



const getFinances = () => fetchData({
    url: `${APIURL}/dashboard/finances`
});


const getWorkDone = () => fetchData({
    url: `${APIURL}/dashboard/analytics/work-done`
});


const getWorkDoneWeekly = () => fetchData({
    url: `${APIURL}/dashboard/analytics/work-done-weekly`
});




export {
    getFinances,
    getWorkDone,
    getWorkDoneWeekly
}